import React, { useState } from 'react';
import Translate from '../Translate/Translate';
import Alert, { Type } from './../Alert';
import Input from '../Forms/Input/Input';
import useStores from '../../hooks/useStores';

interface Props {
  toggle?: () => void;
}

const ResetPassword = ({ toggle }: Props) => {
  const { authentication } = useStores();
  const [resetEmail, setResetEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [feedback, setFeedback] = useState('');

  const handleValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setResetEmail(event.target.value);
  };

  const sendResetEmail = async () => {
    if (!resetEmail) {
      setErrorMessage('email');
      return;
    }

    if (!resetEmail.includes('@') || !resetEmail.includes('.')) {
      setErrorMessage('authemail');
      return;
    }

    setErrorMessage('');

    authentication.resetEmail = resetEmail;

    try {
      const data = await authentication.sendResetEmail();
      if (data.message === 'Reset link sent to your email.') {
        setFeedback('reset-success');
        setTimeout(() => {
          setFeedback('');
        }, 5000);
      }
      setErrorMessage('');
      setResetEmail('');
      authentication.resetEmail = '';
    } catch (error: any) {
      if (
        error?.message === 'Request failed with status code 500' ||
        error?.message === '"The given data was invalid."'
      ) {
        setErrorMessage('reset-fail');
      }
    }
  };

  return (
    <div className="flex flex-wrap flex-col">
      <h3 className="mt-5 text-3xl leading-10 font-axi-bold">
        <Translate component="login" keyword="forgot-message" />
      </h3>
      <p className="leading-7 text-sm font-axi-book mx-0 my-2.5">
        <Translate component="login-reset" keyword="info" />
      </p>
      <div className="flex flex-col mt-4">
        <Input
          className="pb-5 lg:pb-2.5 lg:pr-2.5 px-0"
          type="text"
          name="resetEmail"
          id="resetEmail"
          onChange={handleValueChange}
          value={resetEmail}
          keyword="email"
        />
      </div>
      <div className="flex items-center pb-5">
        <button
          onClick={sendResetEmail}
          className="font-axi-bold cursor-pointer rounded-sm border text-sm leading-7 px-5 py-2 border-solid border-rgrey-light hover:border-rgreen hover:text-white hover:border-solid hover:bg-rgreen bg-white"
        >
          <Translate component="login-reset" keyword="send" />
        </button>
        <button
          onClick={toggle}
          className="underline cursor-pointer ml-auto lg:pr-2.5"
        >
          <Translate component="product" keyword="back" />
        </button>
      </div>
      {feedback ? (
        <Alert show={!!feedback} type={Type.SUCCESS}>
          <Translate component="login-error" keyword={feedback} />
        </Alert>
      ) : null}

      <Alert show={!!errorMessage} type={Type.ERROR}>
        <Translate component="login-error" keyword={errorMessage} />
      </Alert>
    </div>
  );
};

export default ResetPassword;
